import type { LivePackageEntity } from './LivePackageEntity'

export class LivePackageResponseEntity {
  showCompletedPackageDurationInSecond?: number
  showCanceledPackageDurationInSecond?: number
  packages?: Array<LivePackageEntity> | null
}
